<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — FOOTER
     ════════════════════════════════════════════════ -->
<footer class="vfu-footer" role="contentinfo">
  <div class="vfu-footer-inner">

    <div class="vfu-footer-grid">

      <!-- Logo + Description -->
      <div class="vfu-footer-section">
        <div class="vfu-footer-logo">
          <a routerLink="/" aria-label="الصفحة الرئيسية">
            <img [src]="createImgPath(logoFooter)" alt="شعار المنظمة">
          </a>
          <p>
            {{"MENU.Visionforummah" | translate}}
          </p>
        </div>
        <div class="vfu-footer-social">
          <a (click)="openSocalMediaNewWindow(faceBook)" title="فيسبوك" tabindex="0" role="button">
            <i class='bx bxl-facebook'></i>
          </a>
          <a (click)="openSocalMediaNewWindow(twitter)" title="تويتر" tabindex="0" role="button">
            <i class='bx bxl-twitter'></i>
          </a>
          <a (click)="openSocalMediaNewWindow(instagram)" title="إنستغرام" tabindex="0" role="button">
            <i class='bx bxl-instagram'></i>
          </a>
          <a (click)="openSocalMediaNewWindow(linkedin)" title="لينكدإن" tabindex="0" role="button">
            <i class='bx bxl-linkedin'></i>
          </a>
          <a (click)="openSocalMediaNewWindow(youtube)" title="يوتيوب" tabindex="0" role="button">
            <i class='bx bxl-youtube'></i>
          </a>
        </div>
      </div>

      <!-- Quick Links -->
      <div class="vfu-footer-section">
        <h4>{{"MENU.UsefulLink" | translate}}</h4>
        <nav class="vfu-footer-links" aria-label="روابط سريعة">
          <a routerLink="/about">{{"MENU.About" | translate}}</a>
          <a routerLink="/news">{{"MENU.News" | translate}}</a>
          <a routerLink="/public-news">{{"MENU.PublicNews" | translate}}</a>
          <a routerLink="/activity">{{"MENU.Activity" | translate}}</a>
          <a routerLink="/contact">{{"MENU.Contact" | translate}}</a>
        </nav>
      </div>

      <!-- Contact -->
      <div class="vfu-footer-section">
        <h4>{{"MENU.ContactUs" | translate}}</h4>
        <div class="vfu-footer-contact">
          <div class="vfu-contact-row" *ngIf="location">
            <i class='bx bx-map'></i>
            <a [href]="locationMap" target="_blank" rel="noopener noreferrer">{{location}}</a>
          </div>
          <div class="vfu-contact-row" *ngIf="phone">
            <i class='bx bx-phone-call'></i>
            <a [href]="'tel:' + phone">{{phone}}</a>
          </div>
          <div class="vfu-contact-row" *ngIf="email">
            <i class='bx bx-envelope'></i>
            <a [href]="'mailto:' + email">{{email}}</a>
          </div>
        </div>
      </div>

    </div>

    <!-- Bottom bar -->
    <div class="vfu-footer-bottom">
      <p>
        &copy; {{ currentDateStr }} &mdash; {{"MENU.Visionforummah" | translate}}. جميع الحقوق محفوظة.
      </p>
    </div>

  </div>
</footer>

<!-- Scroll to Top -->
<ngx-scrolltop
  [mode]="'classic'"
  [position]="'bottom-left'"
  [size]="'medium'"
  [ariaLabel]="'العودة للأعلى'">
</ngx-scrolltop>
